import type { LocaleDictionary } from "@/i18n/types";

const nsAppEN = {
  loading: {
    defaultText: "Loading data...",
    organizations: "Loading organizations...",
    frontendAddon: "Loading front-end add-ons...",
  },
  undo: {
    actionLabel: "Undo",
    inProgress: "Undoing...",
    success: "Undone",
    error: "Failed to undo. Please try again.",
  },
} satisfies LocaleDictionary;

export default nsAppEN;
